import { render, staticRenderFns } from "./MyPageHeader2.vue?vue&type=template&id=605bae6c&scoped=true&"
import script from "./MyPageHeader2.vue?vue&type=script&lang=js&"
export * from "./MyPageHeader2.vue?vue&type=script&lang=js&"
import style0 from "./MyPageHeader2.vue?vue&type=style&index=0&id=605bae6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605bae6c",
  null
  
)

export default component.exports